import { firestoreService } from './firestoreService';
import { where } from 'firebase/firestore';

export interface CreditBalance {
  balance: number;
  updatedAt: any;
  dailyReset?: boolean;
  resetAt?: any;
}

export interface CreditTransaction {
  id: string;
  userId: string;
  amount: number;
  action?: string;
  reason?: string;
  balanceAfter: number;
  timestamp: any;
}

export const creditsService = {
  async getBalance(userId: string): Promise<number> {
    const creditDoc = await firestoreService.getDocument<CreditBalance>('credits', userId);
    return creditDoc?.balance || 0;
  },

  async getTransactions(userId: string, limitCount: number = 50): Promise<CreditTransaction[]> {
    const transactions = await firestoreService.getDocuments<CreditTransaction>(
      'creditTransactions',
      [
        where('userId', '==', userId),
        firestoreService.orderBy('timestamp', 'desc'),
        firestoreService.limit(limitCount),
      ]
    );
    return transactions;
  },

  async getUserTier(userId: string): Promise<'free' | 'premium' | 'enterprise'> {
    // Get tier from credits collection instead of users collection
    const creditsDoc = await firestoreService.getDocument<{ tier?: 'free' | 'premium' | 'enterprise' }>('credits', userId);
    return creditsDoc?.tier || 'free';
  },
};

